export default "__VITE_ASSET__DKP8eG$4__"